import React from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { PageTitle } from '../blocks';

// A full-page message shown in place of a page's content.
const PageNotice = ({ title, children }) => (
    <Grid
        container
        direction="column"
        css={css`
            height: 100%;
            background: ${colors.white.primary};
            align-items: center;
            justify-content: center;
            padding: 4rem;
            text-align: center;
            gap: 12px;
        `}
    >
        <PageTitle>{title}</PageTitle>
        {children}
    </Grid>
);

export default PageNotice;
